import React from 'react';
import PropTypes from 'prop-types';
import config from 'cfg';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { FlatButton, IconButton, Dialog } from 'material-ui';
import CreditCardIcon from 'material-ui/svg-icons/action/credit-card';
import CopyIcon from 'material-ui/svg-icons/content/content-copy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { grey300 } from 'material-ui/styles/colors';
import moment from 'moment';
import { getEntities, getQueries } from 'dash-front/selectors';
import { OddsList } from './OddsList';
import { getUrlWithCampaign, getUrlAndText } from './utils';
import { oddsSelection } from './actions';
import { showSnackBarMessage } from 'dash-front/components/GlobalSnackbar';
import EventPicker from 'dash-front/components/pickers/EventByDatePicker';
import { setEventId } from 'dash-front/odds/actions';
import { fetchEventById } from 'dash-front/actions';

const EventInfo = connect((state, { eventId }) => ({
    event: get(getEntities(state), ['events', eventId]),
    pending: get(getQueries(state), [`events/${eventId}`, 'isPending']),
}))(({ pending, event }) => {
    if (pending) {
        return <div>Loading...</div>;
    }
    return event ? (
        <div style={{ textAlign: 'center' }}>
            {event.homeName} - {event.awayName}
            <br />
            {event.statusFull}
            <br />
            {moment(event.startDate).format('DD MMM YYYY HH:mm')}
        </div>
    ) : (
        <div>Event not found</div>
    );
});

export const OddsPicker = connect(state => {
    const { selectedOrder, selectedCampaign, selectedProvider, eventId } = oddsSelection.select(state);
    const { socialCampaigns, outcomes, betOffers, events = {} } = getEntities(state);

    return {
        outcomes,
        betOffers,
        selectedOrder,
        selectedCampaign,
        selectedProvider,
        socialCampaigns,
        event: events[eventId],
        user: get(state, 'user', {}),
        bitlyAccessToken:
            (get(state, ['user', 'defaultProps'], []).find(({ key = '' }) => key === 'bitlyAccessToken') || {})
                .bitlyAccessToken || config.bitlyKey,
    };
})(
    class extends React.Component {
        static propTypes = {
            disabled: PropTypes.bool,
            markets: PropTypes.array,
            socialCampaigns: PropTypes.array,
            eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            bitlyAccessToken: PropTypes.string.isRequired,
            onAdd: PropTypes.func,
        };

        constructor(props, ctx) {
            super(props, ctx);

            this.state = {
                open: false,
                eventId: props.eventId,
                // selection
                selectedText: null,
                generatedLink: null,
            };
        }

        componentWillReceiveProps({ selectedOrder, outcomes, betOffers, selectedProvider, event }) {
            if (
                this.props.selectedOrder !== selectedOrder ||
                this.props.outcomes !== outcomes ||
                this.props.betOffers !== betOffers ||
                this.props.selectedProvider !== selectedProvider ||
                this.props.event !== event
            ) {
                this.updateTextAndUrl({ selectedOrder, outcomes, betOffers, event, selectedProvider });
            }
        }

        componentWillUnmount() {
            clearTimeout(this.copiedTimer);
        }

        updateTextAndUrl = ({ selectedOrder, outcomes, betOffers, selectedProvider, event }) => {
            const { url, text } = getUrlAndText({ selectedOrder, outcomes, betOffers, event, selectedProvider });
            this.setState({ selectedText: text, generatedLink: url });
        };

        open = e => {
            this.setState({ open: true, target: e.target });
        };

        close = () => {
            this.setState({
                open: false,
                selectedText: null,
                generatedLink: null,
            });
        };

        onOutcomeChange = ({ selectedText, generatedLink }) => {
            console.log(selectedText, generatedLink);
            this.setState({
                selectedText,
                generatedLink,
            });
        };

        onAdd = ({ message, url }) => () => {
            if (this.props.onAdd) {
                this.props.onAdd({ message, url, bitlyAccessToken: this.props.bitlyAccessToken });
            }
            this.close();
        };

        onCopy = () => {
            this.props.dispatch(showSnackBarMessage('URL was copied to clipboard', 1500));
        };

        handleEventPickerChange = (keyChanged, value) => {
            if (keyChanged === 'eventId') {
                this.setState({ eventId: value });
                this.props.dispatch(setEventId(value));
                this.props.dispatch(fetchEventById(value));
            }
        };

        render() {
            const { selectedText, generatedLink } = this.state;
            const { socialCampaigns, selectedCampaign } = this.props;
            const hasText = Boolean(selectedText);
            const hasLink = Boolean(generatedLink);
            const urlWithCampaign = generatedLink
                ? getUrlWithCampaign(generatedLink, socialCampaigns, selectedCampaign)
                : null;
            return (
                <div style={{ display: 'flex' }}>
                    <IconButton onClick={this.open}>
                        <CreditCardIcon />
                    </IconButton>
                    <Dialog
                        title="Odds picker"
                        open={this.state.open}
                        className="no-padding-dialog"
                        titleStyle={{ borderBottom: '1px solid ' + grey300 }}
                        actionsContainerStyle={{ borderTop: '1px solid ' + grey300 }}
                        autoScrollBodyContent
                        autoDetectWindowHeight
                        onRequestClose={this.close}
                        actions={[
                            <FlatButton
                                key="Text"
                                disabled={!hasText}
                                label="Text"
                                onClick={this.onAdd({ message: selectedText })}
                            />,
                            <FlatButton
                                key="Text+Link"
                                disabled={!hasText || !hasLink}
                                primary
                                label="Text + link"
                                onClick={this.onAdd({ message: selectedText, url: urlWithCampaign })}
                            />,
                            <FlatButton
                                key="Link"
                                disabled={!hasLink}
                                label="Link"
                                onClick={this.onAdd({ url: urlWithCampaign })}
                            />,
                        ]}
                    >
                        <div style={{ padding: 12 }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                {this.props.eventId && <EventInfo eventId={this.props.eventId} />}
                                {!this.props.eventId && (
                                    <EventPicker eventId={this.state.eventId} onChange={this.handleEventPickerChange} />
                                )}
                            </div>
                            <OddsList />
                        </div>
                        <div
                            style={{
                                position: 'absolute',
                                bottom: 2,
                                maxWidth: 450,
                                display: 'inline-flex',
                                alignItems: 'center',
                            }}
                        >
                            <CopyToClipboard text={urlWithCampaign} onCopy={this.onCopy}>
                                <IconButton
                                    disabled={!urlWithCampaign}
                                    tooltip="Copy url to clipboard"
                                    tooltipPosition="top-center"
                                >
                                    <CopyIcon />
                                </IconButton>
                            </CopyToClipboard>
                            <div
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                URL: {urlWithCampaign || 'none'}
                            </div>
                        </div>
                    </Dialog>
                </div>
            );
        }
    },
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/odds/OddsPicker.js
 **/